import { render } from "./bethistory.vue?vue&type=template&id=6a08ed80"
import script from "./bethistory.vue?vue&type=script&lang=js"
export * from "./bethistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__